import { render, staticRenderFns } from "./IndexBlock.vue?vue&type=template&id=64d77dae&scoped=true&"
import script from "./IndexBlock.vue?vue&type=script&lang=js&"
export * from "./IndexBlock.vue?vue&type=script&lang=js&"
import style0 from "./IndexBlock.vue?vue&type=style&index=0&id=64d77dae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d77dae",
  null
  
)

component.options.__file = "IndexBlock.vue"
export default component.exports